var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 30 31"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M15 1.82c.614 0 1.111.497 1.111 1.11v11.46h11.46a1.111 1.111 0 0 1 0 2.223H16.11v11.46a1.111 1.111 0 1 1-2.222 0v-11.46H2.429a1.111 1.111 0 1 1 0-2.223h11.46V2.93c0-.613.497-1.11 1.111-1.11",
    clipRule: "evenodd"
  })));
};
export default SvgPlus;